var downloadZip = function(url, fileName, body, method) {
	var deferred = $.Deferred();
	
	//Allow others to pass in either a relative path, i.e. 'ws/topaz/teams/profiles/'
	//or a full path, i.e. 'http://localhost:48080/ws/topaz/teams/profiles/'
	if(url.indexOf('http') === -1) {
		url = $('base').attr('href') + url;
	}
    
    if(!method) {
    	method = "GET";
    }
    
    if(!fileName) {
    	fileName = "data.zip";
    }
    
    if(!body) {
    	body = null;
    }
    
    var xhr = new XMLHttpRequest();
    
    xhr.open(method, url);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.responseType = "arraybuffer";
    
    xhr.onload = function () {
    
    	if(xhr.status === 200) {
    		var blob = new Blob([xhr.response], {type: "application/zip"});

	        if (navigator.msSaveOrOpenBlob) {
	            // this is for IE, because...Microsoft!!!
	            navigator.msSaveOrOpenBlob(blob, fileName);
	        } else {
	            var linkElement = document.createElement('a');
	            var zipURL = URL.createObjectURL(blob);
	            
	            linkElement.style = 'display : none';
	            linkElement.href = zipURL;
	            linkElement.download = fileName;
	
	            document.body.appendChild(linkElement); // without this line, and...
	            linkElement.click();
	            
	            setTimeout(function() { // ...without these lines, FireFox fails to download the file
	                document.body.removeChild(linkElement);
	                URL.revokeObjectURL(zipURL);
	            }, 100);
	        }
	        
	        deferred.resolve();
    	} else {
    		deferred.reject(xhr.status, xhr.statusText);
    	}
    };
    
    xhr.send(body);
    
    return deferred.promise();
};